import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps } from "react";

const Log32 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32" {...props}>
            <path
                fill="currentColor"
                d="M8 9a3.667 3.667 0 0 1 3.666-3.667H23.5c1 0 1.816.563 2.343 1.293.528.731.823 1.692.823 2.707v.333a1 1 0 0 1-1 1h-3v12a4.24 4.24 0 0 1-1.049 2.78c-.608.695-1.488 1.22-2.451 1.22H9A3.667 3.667 0 0 1 5.333 23v-.667a1 1 0 0 1 1-1H8zm-.633 14.333c.155.76.827 1.333 1.633 1.333h7.42a4.7 4.7 0 0 1-.375-1.333zm10.299-8.667a1 1 0 0 1 0 2H13a1 1 0 1 1 0-2zm0-4a1 1 0 0 1 0 2H13a1 1 0 1 1 0-2zM23.5 7.333c-.15 0-.317.057-.496.373-.13.23-.236.555-.292.96h1.882a2.4 2.4 0 0 0-.373-.87c-.257-.354-.525-.463-.721-.463m-13.5 14h7a1 1 0 0 1 1 1v.333c0 .642.19 1.182.445 1.536.257.356.525.464.721.464.233 0 .604-.146.946-.537.33-.376.554-.897.554-1.463V9.333c0-.693.097-1.386.318-2h-9.318C10.746 7.333 10 8.08 10 9z"
            />
        </svg>
    );
};

const Log24 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
            <path
                fill="currentColor"
                d="M6 6.75A2.75 2.75 0 0 1 8.75 4h8.875c.75 0 1.361.422 1.757.97S20 6.239 20 7v.25a.75.75 0 0 1-.75.75H17v9a3.18 3.18 0 0 1-.787 2.085c-.456.52-1.116.915-1.838.915H6.75A2.75 2.75 0 0 1 4 17.25v-.5a.75.75 0 0 1 .75-.75H6zM5.525 17.5c.116.57.62 1 1.225 1h5.565a3.5 3.5 0 0 1-.28-1zM13.25 11a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zm0-3a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zm4.375-2.5c-.113 0-.238.043-.372.28a2.1 2.1 0 0 0-.219.72h1.412a1.8 1.8 0 0 0-.28-.652c-.193-.267-.394-.348-.541-.348M7.5 16h5.25a.75.75 0 0 1 .75.75V17c0 .481.142.887.334 1.152.193.267.394.348.541.348.175 0 .453-.11.71-.403A1.68 1.68 0 0 0 15.5 17V7c0-.52.072-1.04.238-1.5H8.75c-.69 0-1.25.56-1.25 1.25z"
            />
        </svg>
    );
};

const Log16 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
            <path
                fill="currentColor"
                d="M4 4.5c0-1.012.822-1.833 1.834-1.833h5.916c.5 0 .908.281 1.172.646.264.366.412.846.412 1.354v.167a.5.5 0 0 1-.5.5h-1.5v6c0 .545-.214 1.035-.524 1.39-.267.304-.637.542-1.048.597l-.178.013H4.5A1.834 1.834 0 0 1 2.667 11.5v-.333a.5.5 0 0 1 .5-.5H4zm-.316 7.167c.077.38.413.667.816.667h3.71a2.4 2.4 0 0 1-.188-.667zm5.15-4.333a.5.5 0 0 1 0 1H6.5a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1H6.5a.5.5 0 0 1 0-1zm2.916-1.667c-.075 0-.158.029-.248.187a1.4 1.4 0 0 0-.144.48h.94a1.2 1.2 0 0 0-.187-.435c-.128-.177-.263-.232-.361-.232m-6.75 7h3.5a.5.5 0 0 1 .5.5v.167c0 .32.095.59.223.768s.263.232.361.232c.117 0 .301-.074.473-.27a1.12 1.12 0 0 0 .277-.73V4.667c0-.346.049-.693.16-1h-4.66A.834.834 0 0 0 5 4.5z"
            />
        </svg>
    );
};

export const LogIcon = createIcon(Log16, Log24, Log32, "LogIcon");
